import { createFileRoute } from '@tanstack/react-router'
import { LeavePage } from '@/features/employee-portal/pages/LeavePage'

export const Route = createFileRoute('/employee/leave/')({
  component: LeavePage,
})
